import React from 'react'
import styled from 'styled-components'
import { ModalSearch, Nin, NinImg, Passport } from 'src/assets'
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  h3 {
    font-weight: bold;
    font-size: 14.8px;
    line-height: 22px;
    letter-spacing: 0.69375px;
    color: #003a00;
  }
  h5 {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 22px;
    letter-spacing: 0.69375px;
    color: ${({ theme }) => theme.colors.dark};
  }
  span {
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  .search {
    padding-top: 10px;
  }
`
const ModalPopup = () => {
  return (
    <Wrapper>
      <h3>Driver’s Licence Sample</h3>
      <img src={Nin} alt="" />
      <img src={ModalSearch} alt="" className="search" />
      <h5>
        Dont’t have a Driver’s Licence? Visit <span>FRSC Website</span>
      </h5>
    </Wrapper>
  )
}
const NinPopup = () => {
  return (
    <Wrapper>
      <h3>NIN Sample</h3>
      <img src={NinImg} alt="" />
      <img src={ModalSearch} alt="" className="search" />
      <h5>
        Dont’t have a NIN? Visit <span>NIMCWebsite</span>
      </h5>
    </Wrapper>
  )
}
const PassportW = () => {
  return (
    <Wrapper>
      <h3>Intl. Passport Sample</h3>
      <img src={Passport} alt="" />
      <img src={ModalSearch} alt="" className="search" />
    </Wrapper>
  )
}

export { ModalPopup, NinPopup, PassportW }
